import React from "react";
import AutoScroll from "./AutoScroll";
import { useStore } from "@/store/StoreContext";
import { imgSrc } from "@/lib/api";

const WA_NUMBER = "917208819922";

export function WhatsAppIcon({ size = 16 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413Z"/>
    </svg>
  );
}

export default function TopSelling() {
  const { showcase, content } = useStore();
  const items = showcase.topseller || [];
  if (!items.length) return null;
  return (
    <section id="top-selling" data-testid="top-selling" className="relative py-12 lg:py-16">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="reveal mb-9 text-center">
          <p className="mb-3 text-[11px] font-semibold uppercase tracking-[0.34em] text-[#8F6E1D]">{content?.topselling_eyebrow || "Sacred Collection"}</p>
          <h2 className="font-display text-3xl font-semibold tracking-tight text-[#2B1E12] sm:text-4xl lg:text-5xl">
            {content?.topselling_title || "Our Top-Selling"} <span className="text-gold-gradient italic">{content?.topselling_accent || "Rudraksha"}</span>
          </h2>
          <p className="font-display mx-auto mt-4 max-w-xl text-lg italic text-[#6B5B45]">
            {content?.topselling_subtext || "Handpicked, lab-certified Rudraksha for every intention — authentically sourced and expertly curated."}
          </p>
        </div>
        <AutoScroll testid="topselling-scroller" speed={1.15} itemWidth={280}>
          {items.map((p) => (
            <article
              key={p.name}
              data-testid={`topseller-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="card-3d flex h-full flex-col overflow-hidden rounded-lg border border-[#E0D3B4] bg-white shadow-[0_10px_30px_-14px_rgba(143,110,29,0.25)]"
            >
              <div className="relative aspect-[4/3] w-full overflow-hidden bg-[#F7F0DF]">
                <img src={imgSrc(p.image)} alt={p.name} loading="lazy"
                  className="h-full w-full object-cover transition-transform duration-500 ease-out hover:scale-[1.05]" />
              </div>
              <div className="flex flex-1 flex-col gap-2 border-t border-[#E9DFC8] p-5">
                <h3 className="font-display text-xl font-semibold leading-snug text-[#2B1E12]">{p.name}</h3>
                <p className="line-clamp-2 text-sm leading-relaxed text-[#6B5B45]">{p.text}</p>
              </div>
            </article>
          ))}
        </AutoScroll>
        <div className="mt-9 text-center">
          <a
            data-testid="talk-to-expert"
            href={`https://wa.me/${WA_NUMBER}?text=${encodeURIComponent("Namaste Rudralife, I have selected a product from your Top-Selling Rudraksha collection and want to know more about it.")}`}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2.5 rounded-full bg-[#25D366] px-8 py-4 text-xs font-bold uppercase tracking-[0.18em] text-white shadow-[0_14px_35px_-10px_rgba(37,211,102,0.55)] transition-all duration-300 hover:scale-105 hover:bg-[#1DA851]"
          >
            <WhatsAppIcon size={17} /> Talk to Expert
          </a>
        </div>
      </div>
    </section>
  );
}
